import styled from "styled-components";
import {
  BREAKPOINT,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  SCROLLBAR_STYLES,
  TableCell,
  TableRow,
} from "../../../constants/Styles";

export const BoardInventoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  gap: 0.5rem;
`;

export const StatusContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const SummaryContainer = styled.div`
  flex: 2;
`;

export const StepsContainer = styled.div`
  flex: 1;
`;

export const LabelWithSort = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  img {
    margin: 0;
  }
`;

export const SubTitle = styled.div`
  color: ${COLORS.secondaryLight};

  > span {
    color: ${COLORS.secondary};
    font-weight: ${FONT_WEIGHT.weight500};
  }
`;

export const BoardsCell = styled(TableCell)`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ContainersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MoveContainersAction = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem;
  align-items: center;
`;

export const ButtonColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

export const OptimizationButtonContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;
`;

export const VerticalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  max-width: 100%;
`;

export const InputBox = styled.div`
  max-width: 100%;
`;

export const HorizontalList = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const VariantInputLabel = styled.label<{ forTooltip: boolean }>`
  font-weight: ${FONT_WEIGHT.weight400};
  font-size: ${FONT_SIZE.size13};
  ${({ forTooltip }) =>
    forTooltip
      ? `color: ${COLORS.secondary};`
      : `color: ${COLORS.secondaryLight}`}
`;

export const CheckboxProtector = styled.div`
  min-width: 1rem;
`;

export const ContainerDetail = styled.div<{ isAllocated: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  ${({ isAllocated }) =>
    isAllocated
      ? `background-color: ${COLORS.black};`
      : `background-color: ${COLORS.midGray};`};
`;

export const ContainerItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 0.95rem;
  font-weight: ${FONT_WEIGHT.weight500};
  overflow-wrap: anywhere;
`;

export const ContainerLocationStatus = styled.div`
  display: flex;
  align-items: center;

  font-size: 0.95rem;
  color: ${COLORS.secondaryLight};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export const EditableCellContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const UpdateQuantityModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
  flex: 1;
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const StatusTable = styled.table`
  width: 100%;
  max-width: 1200px;
  min-width: 400px;
  border-collapse: collapse;
  background: ${COLORS.tableBackground};
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${COLORS.secondaryLight};

  @media (max-width: ${BREAKPOINT}) {
    min-width: 500px;
    font-size: ${FONT_SIZE.size12};
  }
`;

export const ChecklistTable = styled.table`
  width: 100%;
  max-width: 1200px;
  min-width: 250px;
  border-collapse: collapse;
  background: ${COLORS.tableBackground};
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid ${COLORS.secondaryLight};

  @media (max-width: ${BREAKPOINT}) {
    min-width: 500px;
    font-size: ${FONT_SIZE.size12};
  }
`;

export const StatusTableHeader = styled.th`
  background: ${COLORS.darkGray};
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: ${FONT_WEIGHT.weight500};
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size14};
  border-bottom: 1px solid ${COLORS.secondaryLight};
`;

export const StatusTableRow = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid ${COLORS.secondaryLight};
  }

  &:hover {
    background-color: ${COLORS.darkGray};
  }
`;

export const StatusTableCell = styled.td`
  padding: 0.75rem 1rem;
  vertical-align: middle;
  color: ${COLORS.secondary};

  &:first-child {
    font-weight: ${FONT_WEIGHT.weight500};
  }
`;

export const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;

  img {
    margin: 0;
  }
`;

export const StatusDetails = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size14};
  display: flex;
  flex-direction: column;
`;

export const StatusActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const StatusTableContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow-x: auto;
  ${SCROLLBAR_STYLES};

  @media (max-width: ${BREAKPOINT}) {
    padding: 0 0.5rem;
    justify-content: flex-start;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;
export const StencilPanelDetailsRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const PanelDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PartList = styled.ul`
  gap: 1rem;
  margin-left: 1rem;
`;

export const ItemLocationDetails = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const PlacementTypeOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PartRow = styled(TableRow)<{ scanned?: boolean }>`
  &:nth-child(even),
  &:nth-child(odd) {
    ${({ scanned }) => scanned && `background: ${COLORS.standard};`}
  }
`;
